import { useEffect } from 'react';
import { supabase } from './supabaseClient';
import { THEMES, DEFAULT_THEME } from './themes';

function applyTheme(themeKey) {
  const theme = THEMES[themeKey] || THEMES[DEFAULT_THEME];
  const root = document.documentElement;
  Object.entries(theme.vars).forEach(([key, val]) => {
    root.style.setProperty(key, val);
  });
}

export default function ThemeProvider({ children }) {
  useEffect(() => {
    // Apply default immediately so no flash
    applyTheme(DEFAULT_THEME);
    // Then fetch from Supabase
    supabase.from('settings').select('value').eq('key', 'theme').single()
      .then(({ data }) => {
        if (data?.value) applyTheme(data.value);
      }).catch(() => {});
  }, []);

  return children;
}

export { applyTheme };
